exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "button + i {\n    float: left;\n    font-size: 1.2em;\n}\n\n.wrapper {\n    margin-top: 80px;\n    margin-bottom: 80px;\n}\n\n.form-signin, .form-reset-password {\n    max-width: 450px;\n    padding: 15px 35px 45px;\n    margin: 0 auto;\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n.form-signin-header, .form-reset-password-header {\n    margin-top: 20px;\n    margin-bottom: 30px;\n}\n\n.password-forgotten {\n  margin-top: 1.5rem;\n  cursor: pointer;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib!./src/styles/forms.css
// module id = 1107
// module chunks = 0